module.exports = __webpack_public_path__ + "img/6.7429d03c.jpg";